import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBarChart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 19V13C7 12.0681 7 11.6022 6.84776 11.2346C6.64477 10.7446 6.25542 10.3552 5.76537 10.1522C5.39782 10 4.93188 10 4 10C3.06812 10 2.60218 10 2.23463 10.1522C1.74458 10.3552 1.35523 10.7446 1.15224 11.2346C1 11.6022 1 12.0681 1 13V15.8C1 16.9201 1 17.4802 1.21799 17.908C1.40973 18.2843 1.71569 18.5903 2.09202 18.782C2.51984 19 3.0799 19 4.2 19H7ZM7 19H13M7 19V4C7 3.06812 7 2.60218 7.15224 2.23463C7.35523 1.74458 7.74458 1.35523 8.23463 1.15224C8.60218 1 9.06812 1 10 1C10.9319 1 11.3978 1 11.7654 1.15224C12.2554 1.35523 12.6448 1.74458 12.8478 2.23463C13 2.60218 13 3.06812 13 4V19M13 19H15.8C16.9201 19 17.4802 19 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C19 17.4802 19 16.9201 19 15.8V9C19 8.06812 19 7.60218 18.8478 7.23463C18.6448 6.74458 18.2554 6.35523 17.7654 6.15224C17.3978 6 16.9319 6 16 6C15.0681 6 14.6022 6 14.2346 6.15224C13.7446 6.35523 13.3552 6.74458 13.1522 7.23463C13 7.60218 13 8.06812 13 9V19Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgBarChart);
export default ForwardRef;
